<!-- 展品轮播卡片 与 展品详情 -->
<template>
  <div :class='className'>
    <el-image ref="imgViews" style="height: 0;width: 0; display: block" :src="firstImg[0]" :preview-src-list="viewList">
    </el-image>
    <div class="v-exhibits-detail">
      <div class="v-detail-left">
        <div style="position: relative" id="canvasWrap">
          <div class="img-box v-img pointer v--video-img" @click="openVideo">
            <pic-zoom class="pic-zoom-box" :width="450" :height="450" v-if="firstImg" v-show="firstImg.length == 1"
              :wrap="'#canvasWrap'" :leftMargin="25" :url="firstImg[0]" :scale="3"></pic-zoom>
            <template v-if="vData.videoUrl && firstImg && firstImg.length > 1">
              <img :src="firstImg[0]" alt="" />
              <span class="icon-video"></span>
            </template>
            <template v-if="firstImg && firstImg.length == 1">
              <div class="image-view" @click="imgViews">
                <span class="el-icon-search"></span>
              </div>
            </template>
          </div>
          <v-swiper @callback="cb" :option="swiperOption" class="v-swiper"
            v-if="swiperOption.list.length !== 0"></v-swiper>
        </div>

      </div>
      <div class="v-detail-right">
        <!-- 展品信息 -->
        <div class="v-detail-product">
          <div class="v-product-head">
            <div class="product-hot" v-if="vData.recommend">
              <span>{{$t('footprints.preferredExhibitors')}}</span>
            </div>
            <div class="head">
              <div class="title ellipsis-3" v-if="vData.productName">{{ vData.productName }}</div>
              <div class="live-icon-box" v-if="vData.liveState && identity != 'ACTOR'">
                <div class="live-icon" @click="todoCallback('live')">
                  <span data-v-ab5f23f6="" class="iconfont iconzhibo"></span>
                  <span data-v-ab5f23f6="" class="v-live-text">{{liveStatusText(vData.live)}}</span>
                </div>
              </div>
              <template v-if="$store.state.config.hideElement">
                <div class="v-clearfix v-tool-block" v-if="identity != 'ACTOR'">
                  <div class="v-pointer" @click="todoCallback('collect')">
                    <span class="iconfont theme-icon-primary-color"
                      :class="{ 'iconshoucang-xuanzhong': vData['collected'], iconshoucang: !vData['collected'] }"></span>
                    <span>{{ vData['collected'] ? $t('collect[1]') : $t('collect[0]') }}</span>
                  </div>
                  <div class="v-pointer" v-if="vData['pageView']">
                    <span class="el-icon-view theme-icon-primary-color"></span>
                    <span>{{ vData['pageView'] }}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <template v-if="$store.state.config.hideElement && false">
            <div class="v-product-order" v-if="identity != 'ACTOR'">
              <el-button type="primary" class="v-product-order-btn"
                @click="todoCallback('order')">{{$t('order.title')}}</el-button>
            </div>
          </template>
        </div>

        <!-- 展商信息 -->
        <slot name="actor">
          <div class="v-detail-actor">
            <div class="v-company v-clearfix">
              <template v-if="$store.state.config.hideElement">
                <div class="v-clearfix v-company-head">
                  <el-avatar class="v-c-media" :size="56" :src="vData['logoImage'] || defImage('product')"></el-avatar>
                  <el-button v-if="false" size="small" type="primary" class="float-right invite-btn" round
                    :disabled="vData.invite" @click="todoCallback('invite')">{{vData.invite ? $t('finds.invited') :
                    $t('invite')}}</el-button>
                </div>
              </template>
              <div class="v-company-info">
                <div class="name">{{ vData['exhibitorName'] }}</div>
                <div class="info" v-if="vData['exhibitionBoothPart'] || vData['exhibitionBoothNumber']">
                  <!-- <i class="theme-icon-primary-color el-icon-location-information"></i> -->
                  <span v-if="vData['exhibitionBoothPart']">{{ vData['exhibitionBoothPart'] }}</span>
                  <span v-if="vData['exhibitionBoothNumber']">{{ vData['exhibitionBoothNumber'] }}</span>
                </div>
              </div>
              <div class="v-c-btns flex fsb">
                <el-button class='v-c-btn no-radius' type="primary"
                  @click="pageDetail(vData, 'actor')">{{$t('finds.enterDetail')}}</el-button>
                <!-- <el-button class='v-c-btn no-radius' @click="todoCallback('message')"
                  v-if="$store.state.config.hideElement">{{$t('finds.contcatUs')}}</el-button> -->
                <!-- <el-button class='v-c-btn no-radius' v-if="$store.state.config.hideElement">{{ $t('message') }}</el-button> -->
              </div>
            </div>
          </div>
        </slot>

        <div class="v-share text-right" v-if="false">
          <AddThis publicId="ra-5ee1a595d2a288a7" />
          <span class="copy-btn" v-clipboard:copy="pageURL" v-clipboard:success="onCopy">{{ $t('Copy Link') }}</span>
        </div>

        <div class="v-footer" v-if="subjectType == 'ACTOR'">
          <!-- <slot name="footer">
            <div class="flex-start align-center">
              <div class="pointer" @click="cb('editor', { id: vData.id })">
                <span class="iconfont iconact_jiaobiaobianji v-color"></span>
                <span class="font-size-13">{{ $t('editor') }}</span>
              </div>
              <div class="pointer" @click="cb('del', { id: vData.id })"  style="margin-left: 20px">
                <span class="iconfont iconqingkong- v-color"></span>
                <span class="font-size-13">{{ $t('del') }}</span>
              </div>
            </div>
          </slot> -->
        </div>
      </div>
      <v-video :isShow="isShowV" :src="vData.videoUrl" @callback="closeVideo"></v-video>
    </div>
  </div>
</template>
<script>
import AddThis from '@/components/AddThis'
import vSwiper from '@/components/vSwiper'
import vVideo from '@/components/vVideo'
import PicZoom from '@/components/piczoom'
import { mapGetters } from 'vuex'

export default {
  name: 'vexhibitsDetail',
  components: {
    AddThis,
    vSwiper,
    vVideo,
    PicZoom
  },
  props: {
    vData: {
      type: [Object],
      default: () => {}
    },
    className: {
      type: String,
      default: ''
    },
    // 一屏显示几张图片
    slides: {
      type: Number,
      default: 7
    },
    // 身份（展商看自己的展品时）
    identity: {
      type: String,
      default: ''
    }
  },
   computed: {
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType'])
  },
  data() {
    return {
      swiperOption: {
        imgW: '88px',
        imgH: '88px',
        slidesPerView: this.slides,
        list: [],
        active: 0
      },
      viewList: [],
      firstImg: '',
      isShowV: false,
      pageURL: window.location.href
    }
  },
  watch: {
    vData: {
      handler() {
        let _this = this
        _this.swiperImgList()
      },
      deep:true
    }
  },
  mounted() {
    this.swiperImgList()
  },
  methods: {
    swiperImgList() {
      let _list = []
      if(JSON.stringify(this.vData) == '{}' || this.imgInit) {
        return
      }
      if(this.vData.videoUrl) {
        _list.push(this.vData.previewImageUrl+","+this.vData.videoUrl)
      }
      if (this.vData.iconUrl) {
        this.vData.iconUrl.split(',').forEach(element => {
          if (element) {
            _list.push(element)
            this.viewList.push(element)
          }
        })

        this.firstImg = _list[0].split(",")
      }

      if(_list.length != 0) {
        this.firstImg = _list[0].split(",")
      }

      this.swiperOption.list = this.minImageThree(_list)
      this.imgInit = true
    },
    imgViews() {
      document.querySelector('.el-image__preview').click()
    },
    onCopy() {
      this.$notify({
        title: this.$t('tip.success'),
        message: this.$t('Copied'),
        type: 'success'
      })
    },
    cb(type, param) {
      var obj = { type: type, data: param }
      if (typeof type !== 'string') {
        obj = type
      }
      if(type.type == 'swiper' && type.data && type.data.item) {
        this.swiperOption.active = type.data.index
        this.firstImg = type.data.item.split(',')
      }
      this.$emit('callback', obj)
    },
    openVideo() {
      if (this.vData.videoUrl && this.firstImg.length > 1) {
        this.isShowV = true
      }
    },
    closeVideo() {
      this.isShowV = false
    },
    todoCallback(todo) {
      this.$emit('todoCallback', todo, this.vData)
    }
  }
}
</script>
<style lang="stylus">
  .image-view {
    .el-image {
      z-index: 100;
    }
    .el-image > img {
      opacity: 0;
    }
  }
</style>

<style lang="stylus" scoped>
.image-view {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 60px;
  height: 60px;
  z-index: 1000;

  .el-icon-search {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    font-size: 32px;
    text-align: center;
    line-height: 60px;
    color: $color-white;
    background: $color-black-15;
  }
}

.v-detail-product {
  // padding: 24px;
  padding-top: 20px;
  background: $color-white;

  .v-product-head {
    overflow hidden
    
    .product-hot {
      float: left;
      margin-top: 5px;

      & + .head {
        padding-left: 48px;
      }
    }
    
    

    .live-icon-box {
      margin-top: 16px;

      & + .v-tool-block {
        margin-top: 15px;
      }
    }

    .v-tool-block {

      .v-pointer {
        margin-right: 18px;
      }
    }

    .title {
      line-height 1.4444;
      font-size 20px;
      font-weight: 700;

      & + .v-tool-block {
        // margin-top: 15px;
      }
    }
  }
  // 暂时隐藏意向订单
  .v-product-order {
    margin-top: 42px;
    text-align center
  }

  .v-product-order-btn {
    width: 430px;
    height: 48px;
    font-size: 18px;
    border-radius: 0px;
  }
}

.v-detail-actor {
  margin-top: 24px;
  // padding: 24px;
  background: $color-white;

  .v-c-media {
    border-radius: 0px;
    vertical-align: top;
  }

  .v-company {
    min-height: 90px;
  }

  .v-company-info { 
    margin-top: 12px;

    .name {
      font-size: 16px;
    }

    .info {
      margin-top: 10px;

      span{
        // margin-left: 8px;
      }
    }
  }

  .invite-btn {
    margin-right: 35px;
    height: 32px;
    font-size: 14px;
  }

  .v-c-btns {
    margin-top: 30px;
    // text-align: center;
  }

  .v-c-btn {
    height: 48px;
    // width: 280px;
    width: 100%;
    border-radius: 4px;

    & + .v-c-btn{
      margin-left: 20px;
    }
  }
}

.pic-zoom-box {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
}

.v-exhibits-detail
  position relative
  overflow hidden

  .v-detail-left
    position relative
    padding: 24px;
    float left
    width 740px
    background $color-white
    box-sizing border-box

    .v-img
      position relative
      height 692px
      background-color $color-black-10

      >>> img
        width: 100%
        height 100%
        object-fit contain

    .v-swiper
      margin 24px 0 20px

  .v-detail-right
    float right
    width 562px
    margin-left: 24px;
    padding-bottom 40px
    position relative

    .v-color
      color $color-main

    .v-title
      font-size 20px
      font-weight: 700;

    span:not('.theme-label')
      color $color-black-65
      font-size 16px

    p
      margin 12px 0
    .v-share
      margin-top: 24px;
      padding: 18px 24px;
      background: $color-white;
      justify-content: space-between;
    .v-footer
      position absolute
      bottom 15px
      left -9px

    .pv
      color $color-black-45 
      font-size 16px


.actor-v-detail {
  .v-exhibits-detail .v-detail-left {
    width: 519px;

    .v-img {
      height: 471px;
    }
  }
}
</style>
